import { MenuType } from "@/types/baseTypes.ts";
import styles from "./LegalMenu.module.scss";
import { useConsentManagementVisibility } from "@aleksundshantu/aunds-cookie-plugin-react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomLink } from "@/components/CustomLink";

interface LegalMenuProps {
  menu: MenuType;
}

export const LegalMenu = ({ menu }: LegalMenuProps) => {
  const { show: showConsentManagement } = useConsentManagementVisibility();
  const { getLabel } = useGlobalContext();
  return (
    <ul
      role="menu"
      id="legal-menu"
      aria-label={getLabel("legal_menu", "legal menu")}
      className={styles.legal}
    >
      {menu.items.map((item, index) => {
        return (
          <li role="none" key={index}>
            {item.classes.includes("cookie-button") ? (
              <button
                role="menuitem"
                key={"footer-menu-link-" + index}
                className="footer-link button-reset"
                onClick={showConsentManagement}
                id={`menuitem-${index}`}
                aria-label={getLabel(
                  "aria_footer_cookie_setting",
                  "öffnet das Cookie-Management-Tool in einem modalen Fenster",
                )}
              >
                {item.title}
              </button>
            ) : (
              item.url && (
                <CustomLink
                  role="menuitem"
                  key={index}
                  href={item.url}
                  target={item.target}
                  className="footer-link"
                  id={`menuitem-${index}`}
                  disablePrefetch // Disable prefetching for footer links https://trello.com/c/g5k075FS
                >
                  {item.title}
                </CustomLink>
              )
            )}
          </li>
        );
      })}
    </ul>
  );
};
